type RoofColor = {
  id: number,
  hexCode: string,
  description1: string,
  description2: string
}

export type ArrayOfColors = Array<RoofColor>

export enum RoofColors {
  DEFAULT  = "DEFAULT",
  GROUP1   = "GROUP1",
  GROUP2   = "GROUP2",
  GROUP3   = "GROUP3",
  GROUP4   = "GROUP4",
  GROUP5   = "GROUP5",
  GROUP6   = "GROUP6",
  GROUP7   = "GROUP7",
  GROUP8   = "GROUP8",
  GROUP9   = "GROUP9",
  GROUP10  = "GROUP10",
  GROUP13  = "GROUP13",
  GROUP14  = "GROUP14",
  GROUP15  = "GROUP15",
  GROUP16  = "GROUP16",
  GROUP17  = "GROUP17",
  GROUP18  = "GROUP18",
  GROUP19  = "GROUP19",
  GROUP20  = "GROUP20",
}

export const defaultColors: ArrayOfColors = [
  // ─── Existing 27 colors ───────────────────────────────────────────────────
  { id: 1, hexCode: '#ddc49a', description1: '1014', description2: 'Ivory' },
  { id: 2, hexCode: '#faca30', description1: '1018', description2: 'Zinc Yellow' },
  { id: 3, hexCode: '#908370', description1: '1035', description2: 'Pearl Beige' },
  { id: 4, hexCode: '#e25303', description1: '2004', description2: 'Pure Orange' },
  { id: 5, hexCode: '#861a22', description1: '3003', description2: 'Ruby Red' },
  { id: 6, hexCode: '#59191f', description1: '3005', description2: 'Wine Red' },
  { id: 7, hexCode: '#6d342d', description1: '3009', description2: 'Oxide Red' },
  { id: 8, hexCode: '#792423', description1: '3011', description2: 'Brown Red' },
  { id: 9, hexCode: '#bb1e10', description1: '3020', description2: 'Traffic Red' },
  { id: 10, hexCode: '#00387b', description1: '5002', description2: 'Ultramarine Blue' },
  { id: 11, hexCode: '#005387', description1: '5005', description2: 'Twilight Azure' },
  { id: 12, hexCode: '#007577', description1: '5021', description2: 'Water Blue' },
  { id: 13, hexCode: '#325928', description1: '6002', description2: 'Leaf Green' },
  { id: 14, hexCode: '#114232', description1: '6005', description2: 'Moss Green' },
  { id: 15, hexCode: '#9b9b9b', description1: '7004', description2: 'Signal Grey' },
  { id: 16, hexCode: '#6c6e6b', description1: '7005', description2: 'Mouse Grey' },
  { id: 17, hexCode: '#45494e', description1: '7024', description2: 'Graphite Grey' },
  { id: 18, hexCode: '#442f29', description1: '8017', description2: 'Chocolate Brown' },
  { id: 19, hexCode: '#ecece7', description1: '9003', description2: 'Signal White' },
  { id: 20, hexCode: '#a1a1a0', description1: '9006', description2: 'Foggy Grey' },
  { id: 21, hexCode: '#e6d2b5', description1: '1015', description2: 'Light Ivory' },
  { id: 22, hexCode: '#c5c7c4', description1: '7035', description2: 'Light Grey' },
  { id: 23, hexCode: '#f1ece1', description1: '9010', description2: 'Pure White' },
  { id: 24, hexCode: '#61993b', description1: '6018', description2: 'Yellow Green' },
  { id: 25, hexCode: '#b9ceac', description1: '6019', description2: 'Pastel Green' },
  { id: 26, hexCode: '#8d4931', description1: '8004', description2: 'Copper Brown' },
  { id: 27, hexCode: '#c8c8c7', description1: '0000', description2: 'Zinc' },
  // ─── New RAL / Ruukki ─────────────────────────────────────────────────────
  { id: 28, hexCode: '#4D3225', description1: 'RR 32', description2: 'Dark Brown (Ruukki)' },
  { id: 29, hexCode: '#55585A', description1: 'RR 23', description2: 'Grey (Ruukki)' },
  { id: 30, hexCode: '#2271B3', description1: '5015', description2: 'Sky Blue' },
  { id: 31, hexCode: '#2C4D24', description1: '6007', description2: 'Bottle Green' },
  { id: 32, hexCode: '#293133', description1: '7016', description2: 'Anthracite Grey' },
  { id: 33, hexCode: '#CDCECB', description1: '7047', description2: 'Telegrey 4' },
  { id: 34, hexCode: '#3B2F2F', description1: '8019', description2: 'Grey Brown' },
  { id: 35, hexCode: '#E7EBDA', description1: '9002', description2: 'Grey White' },
  { id: 36, hexCode: '#0A0A0A', description1: '9005', description2: 'Jet Black' },
  // ─── PURMAN metallic ──────────────────────────────────────────────────────
  { id: 37, hexCode: '#5E6F3D', description1: 'Tourmalin', description2: 'PURMAN Metallic' },
  { id: 38, hexCode: '#4A5D8A', description1: 'Citrine', description2: 'PURMAN Metallic' },
  { id: 39, hexCode: '#5F6F82', description1: 'Galmei', description2: 'PURMAN Metallic' },
  { id: 40, hexCode: '#8B6F47', description1: 'Argillite', description2: 'PURMAN Metallic' },
  // ─── VALORI ───────────────────────────────────────────────────────────────
  { id: 41, hexCode: '#8B8D8E', description1: 'Grey', description2: 'VALORI' },
  { id: 42, hexCode: '#2D3437', description1: 'Dark Grey', description2: 'VALORI' },
  { id: 43, hexCode: '#3B2C20', description1: 'Dark Brown', description2: 'VALORI' },
  { id: 44, hexCode: '#513024', description1: 'Brown', description2: 'VALORI' },
  { id: 45, hexCode: '#2B1A35', description1: 'Violet', description2: 'VALORI' },
  { id: 46, hexCode: '#8A7968', description1: 'Oxi Beige', description2: 'VALORI' },
  // ─── Ecosteel decors ──────────────────────────────────────────────────────
  {
    id: 49,
    hexCode: '#A06A3C',
    description1: 'ECO Zoloty Orekh',
    description2: 'Золотой орех (текст.)',
  },
  {
    id: 50,
    hexCode: '#6E4B20',
    description1: 'ECO Zoloty Dub',
    description2: 'Золотой дуб (текст.)',
  },
  { id: 51, hexCode: '#C79769', description1: 'ECO Sosna Text', description2: 'Сосна (текст.)' },
  { id: 52, hexCode: '#B67A4E', description1: 'ECO Kedr', description2: 'Кедр (текст.)' },
  { id: 53, hexCode: '#A3473A', description1: 'ECO Kirpich', description2: 'Кирпич (глянц.)' },
  { id: 54, hexCode: '#D6A079', description1: 'ECO Orekh', description2: 'Орех (текст.)' },
  { id: 55, hexCode: '#8E5E36', description1: 'ECO Dub', description2: 'Дуб (текст.)' },
  {
    id: 56,
    hexCode: '#7A3F2A',
    description1: 'ECO Antique Dub',
    description2: 'Античный дуб (мат.)',
  },
  { id: 57, hexCode: '#BD7F4A', description1: 'ECO Sosna Matt', description2: 'Сосна (мат.)' },
  { id: 58, hexCode: '#9A8C78', description1: 'ECO Peschanik', description2: 'Песчаник (глянц.)' },
  {
    id: 59,
    hexCode: '#4F2A1C',
    description1: 'ECO Moreny Dub Matt',
    description2: 'Морёный дуб (мат.)',
  },
  {
    id: 60,
    hexCode: '#B9A994',
    description1: 'ECO Beleny Dub',
    description2: 'Белёный дуб (мат.)',
  },
  {
    id: 61,
    hexCode: '#5A2E22',
    description1: 'ECO Moreny Dub Gloss',
    description2: 'Морёный дуб (гл.)',
  },
  { id: 62, hexCode: '#C18150', description1: 'ECO Sosna Gloss', description2: 'Сосна (гл.)' },
  {
    id: 63,
    hexCode: '#C9C4B5',
    description1: 'ECO Bely Kamen',
    description2: 'Белый камень (гл.)',
  },
];

// ─── Metal roof ───────────────────────────────────────────────────────────────
const colorGroupOne: Array<string> = ['1014', '3005', '3011', '5005', '6005', '7004', '7024', '8017', '9003']
const colorGroupTwo: Array<string> = ['1014', '1018', '1035', '2004', '3003', '3005', '3009', '3011', '3020', '5002', '5005', '5021', '6002', '6005', '7004', '7005', '7024', '8017', '9003', '9006']

// GROUP3: Norman MP — 28 colors per presentation
const colorGroupThree: Array<string> = [
  'RR 32', '1014', '1015', '1018', '2004', '3005', '3011', '3020',
  '5002', '5005', '5015', '5021', '6002', '6005', '6018', '6019',
  '7004', '7016', '7024', '7035', '7047', '8004', '8017',
  '9002', '9003', '9005', '9006', '9010',
]
// GROUP4: PURMAN — 12 colors per presentation
const colorGroupFour: Array<string> = [
  'RR 32', '7024', '8017', '9005', '9010',
  '3005', '5005', '6005',
  'Citrine', 'Tourmalin', 'Galmei', 'Argillite',
]
// GROUP5: VikingMP E — 10 colors per presentation
const colorGroupFive: Array<string> = [
  'RR 32', '3005', '6005', '6007', '7016', '7024', '8004', '8017', '8019', '9005',
]

// ─── Prof roof ────────────────────────────────────────────────────────────────
const colorGroupSix: Array<string>   = ['1014', '3005', '3011', '5005', '6005', '7004', '8017', '9003']
const colorGroupSeven: Array<string> = ['1014', '1015', '1035', '2004', '3005', '3009', '3011', '3020', '5002', '5005', '5021', '6002', '6005', '7004', '7005', '7024', '7035', '8017', '9002', '9003', '9006', '9010']
const colorGroupEight: Array<string> = ['1014', '1015', '3005', '3011', '5002', '5005', '6005', '7004', '7024', '8017', '9002', '9003', '9006', '6017', '6019', '8004']
const colorGroupNine: Array<string>  = ['0000']
const colorGroupTen: Array<string>   = ['0000']

// ─── New groups ───────────────────────────────────────────────────────────────
// GROUP13: PureTech Mat
const colorGroupThirteen: Array<string>  = ['7024']
// GROUP14: VALORI
const colorGroupFourteen: Array<string>  = ['Grey', 'Dark Grey', 'Dark Brown', 'Brown', 'Violet', 'Oxi Beige']
// GROUP15: Puretan
const colorGroupFifteen: Array<string>   = ['RR 23', 'RR 32', '8017']
// GROUP16: Matt MP
const colorGroupSixteen: Array<string>   = ['7024', '8017']
// GROUP17: VikingMP standard segment
const colorGroupSeventeen: Array<string> = ['RR 32', '3005', '3011', '6005', '7016', '7024', '8017', '9005']
// GROUP18: SteelMatt
const colorGroupEighteen: Array<string>  = ['RR 32', '7024', '8017']
// GROUP19: Polyester new thicknesses 0.5–1.2mm (27 colors)
const colorGroupNineteen: Array<string>  = [
  'RR 32', '1015', '1018', '1035', '2004', '3003', '3005', '3009', '3011', '3020',
  '5002', '5005', '5015', '5021', '6002', '6005', '6019',
  '7004', '7005', '7024', '8004', '8017',
  '9002', '9003', '9005', '9006', '9010',
]
// GROUP20: Ecosteel (15 decors)
const colorGroupTwenty: Array<string>    = [
  'ECO Zoloty Orekh', 'ECO Zoloty Dub', 'ECO Sosna Text', 'ECO Kedr',
  'ECO Kirpich', 'ECO Orekh', 'ECO Dub', 'ECO Antique Dub',
  'ECO Sosna Matt', 'ECO Peschanik', 'ECO Moreny Dub Matt',
  'ECO Beleny Dub', 'ECO Moreny Dub Gloss', 'ECO Sosna Gloss', 'ECO Bely Kamen',
]

const colors0: ArrayOfColors = []
const colors1  = defaultColors.filter(c => colorGroupOne.includes(c.description1))
const colors2  = defaultColors.filter(c => colorGroupTwo.includes(c.description1))
const colors3  = defaultColors.filter(c => colorGroupThree.includes(c.description1))
const colors4  = defaultColors.filter(c => colorGroupFour.includes(c.description1))
const colors5  = defaultColors.filter(c => colorGroupFive.includes(c.description1))
const colors6  = defaultColors.filter(c => colorGroupSix.includes(c.description1))
const colors7  = defaultColors.filter(c => colorGroupSeven.includes(c.description1))
const colors8  = defaultColors.filter(c => colorGroupEight.includes(c.description1))
const colors9  = defaultColors.filter(c => colorGroupNine.includes(c.description1))
const colors10 = defaultColors.filter(c => colorGroupTen.includes(c.description1))
const colors13 = defaultColors.filter(c => colorGroupThirteen.includes(c.description1))
const colors14 = defaultColors.filter(c => colorGroupFourteen.includes(c.description1))
const colors15 = defaultColors.filter(c => colorGroupFifteen.includes(c.description1))
const colors16 = defaultColors.filter(c => colorGroupSixteen.includes(c.description1))
const colors17 = defaultColors.filter(c => colorGroupSeventeen.includes(c.description1))
const colors18 = defaultColors.filter(c => colorGroupEighteen.includes(c.description1))
const colors19 = defaultColors.filter(c => colorGroupNineteen.includes(c.description1))
const colors20 = defaultColors.filter(c => colorGroupTwenty.includes(c.description1))

export const colors = {
  [RoofColors.DEFAULT]: colors0,
  [RoofColors.GROUP1]:  colors1,
  [RoofColors.GROUP2]:  colors2,
  [RoofColors.GROUP3]:  colors3,
  [RoofColors.GROUP4]:  colors4,
  [RoofColors.GROUP5]:  colors5,
  [RoofColors.GROUP6]:  colors6,
  [RoofColors.GROUP7]:  colors7,
  [RoofColors.GROUP8]:  colors8,
  [RoofColors.GROUP9]:  colors9,
  [RoofColors.GROUP10]: colors10,
  [RoofColors.GROUP13]: colors13,
  [RoofColors.GROUP14]: colors14,
  [RoofColors.GROUP15]: colors15,
  [RoofColors.GROUP16]: colors16,
  [RoofColors.GROUP17]: colors17,
  [RoofColors.GROUP18]: colors18,
  [RoofColors.GROUP19]: colors19,
  [RoofColors.GROUP20]: colors20,
}

export default colors
